<template>
  <transition name="fade-zoom" :duration="200" mode="in-out">
    <modal background v-if="showDialog">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Koniec sesji</p>
        </header>

        <section class="modal-card-body">
          <p>
            Twoja sesja wygaśnie za
            <strong :class="{ 'has-text-danger': lastTenSeconds }">{{
              remainingTime
            }}</strong
            >.
          </p>
          <p>Po tym czasie nastąpi automatyczne wylogowanie.</p>
          <p>Czy chcesz przedłużyć sesję?</p>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" @click="renewToken">
            <icon name="fa-redo" />
            <span>Przedłuż sesję</span>
          </button>
          <button class="button is-danger" @click="signOut">
            <icon name="fa-sign-out-alt" />
            <span>Wyloguj się</span>
          </button>
        </footer>
      </div>
    </modal>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import { Modal } from "%modals";
import { Icon } from "%helpers";

const COUNTDOWN_START = 60;
const COUNTDOWN_AHEAD = COUNTDOWN_START + 90;

export default {
  name: "session-expiration-observer",

  components: {
    Modal,
    Icon
  },

  props: {
    now: dayjs
  },

  data() {
    return {
      remainingSeconds: null,
      lastTenSeconds: false,
      timer: null,
      showDialog: false
    };
  },

  computed: {
    remainingTime() {
      return this.remainingSeconds
        ? dayjs(this.remainingSeconds * 1000).format("mm:ss")
        : "--:--";
    },

    ...mapGetters(["jwtExpirationDate"])
  },

  methods: {
    start() {
      if (
        !this.timer &&
        this.jwtExpirationDate &&
        this.jwtExpirationDate.diff(this.now, "seconds") <= COUNTDOWN_AHEAD
      ) {
        this.timer = setInterval(
          () =>
            (this.remainingSeconds = this.jwtExpirationDate.diff(
              dayjs(),
              "seconds"
            )),
          1000
        );
      }
    },

    prepare() {
      this.timer && clearInterval(this.timer);
      this.showDialog = false;
      this.remainingSeconds = null;
      this.lastTenSeconds = false;
      this.timer = null;
    },

    renewToken() {
      this.prepare();
      this.$emit("renew-token");
    },

    signOut() {
      this.prepare();
      this.$emit("sign-out");
    },

    tokenExpired() {
      this.prepare();
      this.$emit("token-expired");
    }
  },

  mounted() {
    this.start();
  },

  watch: {
    now() {
      this.start();
    },

    jwtExpirationDate() {
      this.prepare();
      this.start();
    },

    remainingSeconds(time) {
      if (time !== null) {
        if (time === 0) {
          this.tokenExpired();
        }

        if (time <= 30) {
          this.lastTenSeconds = true;
        }

        if (!this.showDialog && time <= COUNTDOWN_START) {
          this.showDialog = true;
        }
      }
    }
  }
};
</script>

<style></style>
